import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl } from '@angular/forms';
import { AutomationReference } from '../automacoes-empresa/automacoes-empresa.component';
import { FolderProvider } from 'src/providers/folder/folder';
import * as moment from 'moment';
import { AutomationProvider } from 'src/providers/automation/automation';
import { Snackbar } from 'src/util/snackbar';

interface Folder {
  id: number;
  name: string;
  type: 'DEFAULT' | 'UNSEEN';
}

@Component({
  selector: 'app-confirm-automation-changes',
  templateUrl: './confirm-automation-changes.component.html',
  styleUrls: ['./confirm-automation-changes.component.scss']
})
export class ConfirmAutomationChangesComponent {
  @Input() newlyAdded: AutomationReference[] = [];
  @Input() newlyRemoved: AutomationReference[] = [];

  loading = false;

  startDate: string = '';
  endDate: string = '';
  isUsingFolder: boolean = false;
  folders: Folder[] = [];
  filteredFolders: Folder[] = [];

  folderFilterCtrl = new FormControl('');
  selectedFolderId = null;

  constructor(
    public activeModal: NgbActiveModal,
    public folderProvider: FolderProvider,
    public automationProvider: AutomationProvider,
    public snackBar: Snackbar
  ) { }

  ngOnInit() {
    this.checkFolderNeed();
    this.setupFolderFilter();
  }

  checkFolderNeed() {
    this.isUsingFolder = this.newlyAdded.some(
      (automation: AutomationReference) =>
        automation.automationType === 'MOVE_DFE_TO_FOLDER' ||
        automation.automationType === 'MOVE_CANCELLED_DFE_TO_FOLDER'
    );

    if (this.isUsingFolder) {
      this.loading = true;
      const companyId = localStorage.getItem('idEmpresa');
      this.folderProvider.getFoldersByCompanyId(companyId).then((result: Folder[]) => {
        this.selectedFolderId = (result.find((item) => item.name === "Arquivados")).id;
      }).catch(error => {
        this.snackBar.openLong(error.error.status + ' - ' + error.error.detail, 'erro')
      }).finally(() => {
        this.loading = false;
      }
      )
    }
  }

  setupFolderFilter() {
    this.folderFilterCtrl.valueChanges.subscribe(searchTerm => {
      this.filterFolders(searchTerm);
    });
  }

  filterFolders(searchTerm: string) {
    if (!searchTerm) {
      this.filteredFolders = this.folders;
      return;
    }

    const lowerSearch = searchTerm.toLowerCase();
    this.filteredFolders = this.folders.filter(folder =>
      folder.name.toLowerCase().includes(lowerSearch)
    );
  }

  onConfirm(): void {
    if (this.newlyAdded.length > 0) {
      if (!this.startDate || !this.endDate) {
        return;
      }
      if (this.isUsingFolder && !this.selectedFolderId) {
        return;
      }
    }

    const obj = {
      toRemove: this.newlyRemoved ? this.newlyRemoved.map(auto => auto.groupId) : null,
      toAdd: this.newlyAdded.length ? {
        groupIds: this.newlyAdded.map(auto => auto.groupId),
        startDate: moment(this.startDate).format('YYYY-MM-DDTHH:mm:ss'),
        endDate: moment(this.endDate).format('YYYY-MM-DDTHH:mm:ss'),
        folderId: this.selectedFolderId
      } : null
    };

    this.loading = true;
    this.automationProvider.postAutomationSimplifiedBatchForCompany(obj).then((result) => {
      this.activeModal.close(true);
    }).catch(error => {
      this.loading = false;
      this.snackBar.openLong(error.error.status + ' - ' + error.error.detail, 'erro')
    });

  }

  onCancel(): void {
    this.activeModal.dismiss();
  }
}